var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Welcome',{attrs:{"msg":_vm.msg}}),_c('img',{attrs:{"src":"https://i.ytimg.com/vi/NYNoFGzzHLo/maxresdefault.jpg","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }